// Reusable skeleton placeholders. Render these whenever data is being
// fetched so users get immediate visual feedback instead of a blank page.
import React from "react";

const SHIMMER = {
  background: "linear-gradient(90deg, #F4E7EE 0%, #F9DDE6 50%, #F4E7EE 100%)",
  backgroundSize: "200% 100%",
  animation: "sm-shimmer 1.4s linear infinite",
  borderRadius: 12,
};

export function SkeletonBlock({ height = 16, width = "100%", style }) {
  return <div style={{ ...SHIMMER, height, width, ...style }} aria-hidden />;
}

export function SkeletonCard({ rows = 3 }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid var(--sm-line)",
        borderRadius: 18,
        padding: "16px",
      }}
      role="status" aria-label="Loading"
    >
      <SkeletonBlock height={18} width="55%" style={{ marginBottom: 12 }} />
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonBlock
          key={i}
          height={12}
          width={`${85 - i * 8}%`}
          style={{ marginBottom: 8 }}
        />
      ))}
    </div>
  );
}

export function SkeletonList({ count = 3 }) {
  return (
    <div className="flex flex-col gap-3" role="status" aria-label="Loading items">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} rows={2} />
      ))}
    </div>
  );
}

// Inject the shimmer keyframes once.
if (typeof document !== "undefined" && !document.getElementById("sm-shimmer-css")) {
  const style = document.createElement("style");
  style.id = "sm-shimmer-css";
  style.textContent = `@keyframes sm-shimmer { 0%{background-position:200% 0;} 100%{background-position:-200% 0;} }`;
  document.head.appendChild(style);
}

export default { SkeletonBlock, SkeletonCard, SkeletonList };
